import { CircleQuestionMark } from "lucide-react";
import { useNavigate } from "react-router";
import { Button } from "@/components/ui/button";

type NotFoundDisplayProps = {
  redirectUrl?: string;
  text?: string;
};
export const NotFoundDisplay = ({
  redirectUrl = "/",
  text = "Resource not found",
}: NotFoundDisplayProps) => {
  const navigate = useNavigate();

  return (
    <div className="grid min-h-full place-items-center px-6 py-24 sm:py-32 lg:px-8">
      <div className="text-center">
        <CircleQuestionMark className="h-16 w-16 mx-auto" />
        <h1 className="mt-8 text-2xl font-semibold tracking-tight text-balance sm:text-3xl">
          {text}
        </h1>
        <div className="mt-8 flex items-center justify-center">
          <Button variant="default" onClick={() => navigate(redirectUrl)}>
            <span aria-hidden="true">&larr;</span> Go back
          </Button>
        </div>
      </div>
    </div>
  );
};
